import { fetchWithAuth } from '../helpers';
import { getApiUrl } from '../config/api';

const handleResponse = async (response: Response) => {
  const data = await response.json();
  if (!response.ok) {
    const errorMsg = (data && data.message) || response.statusText;
    return Promise.reject(new Error(errorMsg));
  }
  return data;
};

const holidayDateService = {
  getAll: async (month?: number, year?: number) => {
    const params = new URLSearchParams();
    if (month) params.append('month', String(month));
    if (year) params.append('year', String(year));
    const response = await fetchWithAuth(`${getApiUrl()}/api/holiday-dates?${params.toString()}`, {
      method: 'GET',
      headers: { 'ngrok-skip-browser-warning': '69420' },
    });
    return handleResponse(response);
  },

  create: async (data: { date: string; endDate?: string; name: string }) => {
    const response = await fetchWithAuth(`${getApiUrl()}/api/holiday-dates`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'ngrok-skip-browser-warning': '69420' },
      body: JSON.stringify(data),
    });
    return handleResponse(response);
  },

  update: async (id: number, data: { date: string; endDate?: string; name: string }) => {
    const response = await fetchWithAuth(`${getApiUrl()}/api/holiday-dates/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', 'ngrok-skip-browser-warning': '69420' },
      body: JSON.stringify(data),
    });
    return handleResponse(response);
  },

  delete: async (id: number) => {
    const response = await fetchWithAuth(`${getApiUrl()}/api/holiday-dates/${id}`, {
      method: 'DELETE',
      headers: { 'ngrok-skip-browser-warning': '69420' },
    });
    return handleResponse(response);
  },
};

export default holidayDateService;
